__turbopack_context__.v({
  "tabsgrid": "TabsLayout-module__jRVRTq__tabsgrid",
  "tabslayout": "TabsLayout-module__jRVRTq__tabslayout",
});
